import(/* webpackMode: "eager" */ "/workspace/app/admin/page.tsx");
